import { SectionTitle } from "../ProfileSection/ProfileSection.styles";

import FormProfessional from "../FormProfessional/FormProfessional";

const SectionProfessional = () => {
    return(
        <>
            <SectionTitle>Experiencia Profesional</SectionTitle>
            <FormProfessional />
        </>
    )
}

export default SectionProfessional;